import {BasePanel, BasePanelStyle} from "../BasePanel";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {styleRuleInherit} from "../../../../../stem-core/src/decorators/Style";
import {DonateFlowController} from "../../../flows/DonateFlowController";


class DonationPanelStyle extends BasePanelStyle {
    @styleRuleInherit
    paragraph = {
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_LARGE,
        color: this.themeProps.MERCHANT_TEXT_PRIMARY_COLOR,
    };
}

@registerStyle(DonationPanelStyle)
export class DonationPanel extends BasePanel {
    getControllerClass() {
        return DonateFlowController;
    }
}

